"use client";

import { useEffect } from "react";
import {
	defaultLocale,
	isLocale,
	LOCALE_STORAGE_KEY,
	type Locale,
} from "@/i18n/config";
import { pickBrowserLocale } from "@/i18n/navigation";

export default function RootRedirectPage() {
	useEffect(() => {
		const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
		let target: Locale = defaultLocale;
		if (stored && stored !== "system" && isLocale(stored)) {
			target = stored;
		} else {
			target = pickBrowserLocale();
		}
		const { search, hash } = window.location;
		window.location.replace(`/${target}/${search}${hash}`);
	}, []);

	return (
		<div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm p-8">
			Loading…
		</div>
	);
}
